import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";

export default () => {

  const moduleName = "notifications/user";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [location.search]);

  useEffect(() => {
    if (appReducer.notifications_user_list != undefined) {
      setRows(appReducer.notifications_user_list.data)
      setTotalPages(appReducer.notifications_user_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'پیام',
      selector: row => row.full_text ?? "-",
    },
    {
      name: 'کاربر دریافت کننده',
      selector: row => `${row.user ? row.user.mobile : ""} ${" | "} ${row.user.first_name} ${row.user.last_name}`
    },
    {
      name: 'وضعیت',
      selector: row => row.is_sent ? "ارسال شده" : "ناموفق",
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    }
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};
